import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { toastr } from "react-redux-toastr";

import { EXTENSIONS, MAX_FILE_SIZE, MIN_BALANCE } from "./formSettings";
import { FIELD_FILES } from "../formSettings";

import { FormLayout } from "../components/FormLayout";
import { InputFile } from "./InputFile";
import { Spinner } from "../components/Spinner";

import { fetchUser } from "../../../../api/convertAPI";

import { ImportType } from "../types";

export const FormComponent: React.FC = () => {
  const [acceptExt, setAcceptExt] = useState<string[]>();

  /*
  * 1. fetch user data from convertAPI;
  * 2. check user balance;
  * 3. set accepted extensions
  * */
  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    fetchUser({ signal })
      .then(({ SecondsLeft }) => {
        const ext = SecondsLeft > MIN_BALANCE
          ? EXTENSIONS
          : [".pdf"];

        setAcceptExt(ext);
      })
      .catch((error) => {
        if (error.code !== 20) {
          toastr.error("Convert API", error.message);
        }
      });

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <FormLayout importType={ImportType.computerUpload}>
      {acceptExt
        ? (
          <Field
            name={FIELD_FILES}
            component={InputFile}
            accept={acceptExt}
            maxSize={MAX_FILE_SIZE}
          />
        )
        : <Spinner />}
    </FormLayout>
  );
};
